import { countriesForDropdown } from '../utils/countries';

// Define a configuration object for different shipper types
export const shipperTypeConfigurations = {
    postnl: {
        fields: [
            { name: 'productCode_Europe', type: 'dropdown', label: 'profile_productcode_europe',
                options: [
                    { label: '2928 - NL Brievenbuspakje 24 uur (Ongesorteerd)', value: '2928' },
                    { label: '2929 - NL Brievenbuspakje 24 uur (Gesorteerd)', value: '2929' },
                    { label: '2948 - NL Brievenbuspakje 48 uur', value: '2948' },
                    { label: '3085 - NL Standard Shipment', value: '3085' },
                    { label: '3089 - NL Signature on delivery + Deliver to stated address only', value: '3089' },
                    { label: '3189 - NL Signature on delivery', value: '3189' },
                    { label: '3438 - NL Standard Shipment + Age Check 18+', value: '3438' },
                    { label: '3437 - NL Delivery to neighbor + Age Check 18+', value: '3437' },
                    { label: '3087 - NL Extra cover', value: '3087' },
                    { label: '3090 - NL Delivery to neighbor + Return when not home', value: '3090' },
                    { label: '3094 - NL Extra cover + Return when not home', value: '3094' },
                    { label: '3096 - NL Signature on delivery + Deliver to stated address only + Return when not home', value: '3096' },
                    { label: '3385 - NL Deliver to stated address only', value: '3385' },
                    { label: '3389 - NL Signature on delivery + Return when not home', value: '3389' },
                    { label: '3390 - NL Deliver to stated address only + Return when not home', value: '3390' },
                    { label: '4946 - Belgium Standard delivery', value: '4946' },
                    { label: '4912 - Belgium Parcel Signature on delivery', value: '4912' },
                    { label: '4914 - Belgium Parcel Extra cover', value: '4914' },
                    { label: '4941 - Belgium Parcel Deliver to stated address only', value: '4941' },
                    { label: '4907 - Parcel EU to consumer Track & Trace', value: '4907' },
                    { label: '4907 - Parcel EU to consumer Track & Trace Insured', value: '4907' },
                    { label: '4907 - Parcel EU to consumer Track & Trace Insured Plus', value: '4907' },
                    { label: '4907 - Parcel EU to business Track & Trace', value: '4907' },
                    { label: '4907 - Parcel EU to business Track & Trace Insured', value: '4907' },
                    { label: '4907 - Parcel EU to business Track & Trace Insured Plus', value: '4907' },
                    { label: '4999 - Parcel EU Standard', value: '4999' },
                    { label: '3610 - Cargo AVG Pallet (NL)', value: '3610' },
                    { label: '3618 - Cargo AVG Pallet (EU)', value: '3618' },
                    { label: '3622 - Cargo AVG Pallet (NL)', value: '3622' },
                    { label: '3626 - Cargo AVG Pallet (EU)', value: '3626' },
                    { label: '3657 - Cargo AVG Half Pallet (NL)', value: '3657' },
                    { label: '3658 - Cargo AVG Half Pallet (BE)', value: '3658' },
                    { label: '3659 - Cargo AVG Half Pallet (LU)', value: '3659' },
                    { label: '3630 - Cargo AVG Parcel Plus (NL)', value: '3630' },
                    { label: '3638 - Cargo AVG Parcel Plus (EU)', value: '3638' },
                    { label: '3642 - Cargo AVG Parcel Plus (NL)', value: '3642' },
                    { label: '3627 - Cargo AVG Parcel Plus (EU)', value: '3627' },
                    { label: '3250 - Return label (NL Fulfilments)', value: '3627' },
                    { label: '4882 - Return label (BE Fulfilments)', value: '4882' },
                    { label: '4910 - International return shipments (available in 23 European countries)', value: '4910' },
                    { label: '6945 - International Boxable (Untracked) Bulk', value: '6945' },
                    { label: '6942 - International Boxable (Tracked) Bulk', value: '6942' },
                    { label: '6550 - International Packet (Tracked) Bulk', value: '6550' },
                    { label: '6905 - International Packet (Untracked) Bulk', value: '6905' },
                ]
            },
            { name: 'productCode_OutsideEurope', type: 'dropdown', label: 'profile_productcode_outside_europe',
                options: [
                    { label: '6440 - International Boxable (Untracked)', value: '6440' },
                    { label: '6945 - International Boxable (Untracked) Bulk', value: '6945' },
                    { label: '6972 - International Boxable (Tracked)', value: '6972' },
                    { label: '6942 - International Boxable (Tracked) Bulk', value: '6942' },
                    { label: '6405 - International Packet (Untracked)', value: '6405' },
                    { label: '6905 - International Packet (Untracked) Bulk', value: '6905' },
                    { label: '6350 - International Packet (Tracked)', value: '6350' },
                    { label: '6550 - International Packet (Tracked) Bulk', value: '6550' },
                    { label: '6906 - International Packet Extra (Registered)', value: '6906' },
                    { label: '6908 - International Packet Extra (Registered) Bulk', value: '6908' },
                    { label: '4905 - Great Britain Delivery duty paid (DDP UK)', value: '4905' },
                    { label: '4907 - Parcel EU to consumer Track & Trace', value: '4907' },
                    { label: '4907 - Parcel EU to consumer Track & Trace Insured', value: '4907' },
                    { label: '4907 - Parcel EU to consumer Track & Trace Insured Plus', value: '4907' },
                    { label: '4907 - Parcel EU to business Track & Trace', value: '4907' },
                    { label: '4907 - Parcel EU to business Track & Trace Insured', value: '4907' },
                    { label: '4907 - Parcel EU to business Track & Trace Insured Plus', value: '4907' },
                    { label: '4909 - Non EU Track&Trace Insured Plus (voorheen 4947 GlobalPack)', value: '4909'},
                    { label: '4999 - Parcel EU Standard', value: '4999' },
                    { label: '3618 - Cargo AVG Pallet (EU)', value: '3618' },
                    { label: '3626 - Cargo AVG Pallet (EU)', value: '3626' },
                    { label: '3638 - Cargo AVG Parcel Plus (EU)', value: '3638' },
                    { label: '3627 - Cargo AVG Parcel Plus (EU)', value: '3627' },
                    { label: '4910 - International return shipments (available in 23 European countries)', value: '4910' },
                ]
            },
            { name: 'alternativeCustomerCode', type: 'text', label: 'alternative_customer_code', tooltip: 'alternative_customer_code_text'},
            { name: 'trustedShipperId', type: 'text', label: 'profile_trustedshipperid', tooltip: 'profile_postnl_specialid'},
            { name: 'importerReferenceCode', type: 'text', label: 'profile_importerreferencecode', tooltip: 'profile_postnl_specialid'},
            { name: 'multiColli', type: 'boolean', label: 'profile_multicolli' },
            { name: 'minParcelWeight', type: 'number', label: 'minimum_package_weight_grams' },
            { name: 'ignorePhoneCheck', type: 'boolean', label: 'ignore_phone_check', tooltip: 'em_ignore_phone_check' },
        ],
        returnFields: [
            { name: 'replyNumber', type: 'text', label: 'profile_reply_number', tooltip: 'profile_reply_number_tooltip' },
        ],
        saveObject: {
            productCode_Europe: "",
            productCode_OutsideEurope: "",
            trustedShipperId: "",
            importerReferenceCode: "",
            multiColli: false
        }
    },
    dhl: {
        fields: [
            { name: 'shipmentType', type: 'dropdown', label: 'shipment_type', translate: true, options: [
                { label: 'profile_dhl_send_to_customer', value: 'consumer' },
                { label: 'profile_dhl_send_to_business', value: 'business' },
            ] },
            { name: 'deliveryMethod', type: 'dropdown', label: 'delivery_method', translate: true, options: [
                { label: 'profile_dhl_doordelivery', value: 'doordelivery' },
                { label: 'profile_dhl_mailbox', value: 'mailbox' },
            ] },
            { name: 'sizeAndWeight', type: 'dropdown', label: 'size_and_weight', translate: true, options: [
                { label: 'profile_dhl_size_auto', value: 'AUTO', deliveryMethod: 'both' },
                { label: 'Envelope (50-500g, 38×26.5×3.2 cm)', value: 'ENVELOPE', deliveryMethod: 'mailbox' },
                { label: 'Extra Small (500-2000g, 38×26.5×3.2 cm)', value: 'XSMALL', deliveryMethod: 'mailbox' },
                { label: 'Small (0-10kg, 80×50×35 cm)', value: 'SMALL', deliveryMethod: 'doordelivery' },
                { label: 'Small-Medium (10-20kg, 80×50×35 cm)', value: 'SMALL_MEDIUM', deliveryMethod: 'doordelivery' },
                { label: 'Medium (20-31kg, 180×100×50 cm)', value: 'MEDIUM', deliveryMethod: 'doordelivery' },
                { label: 'Pallet (50-1000kg, 240×100×200 cm)', value: 'PALLET', deliveryMethod: 'doordelivery', shipmentType: "send_to_business" },
            ] },
            { name: 'extraServiceReference', type: 'dropdown', label: 'extra_service_reference', translate: true, options: [
            { label: 'no', value: 'no' },
            { label: 'profile_dhl_reference_default', value: 'default_reference' },
            { label: 'profile_dhl_reference_ordernumber', value: 'order_number' },
            { label: 'profile_dhl_reference_picklistnumber', value: 'picklist_number' }
            ] },
            { name: 'extraServiceReturnLabel', type: 'boolean', label: 'extra_service_return_label' },
            { name: 'extraServiceTransportInsurance', type: 'boolean', label: 'extra_service_transport_insurance' },
            { name: 'extraServiceSignatureOnDelivery', type: 'boolean', label: 'extra_service_signature_on_delivery' },
            { name: 'extraServiceNoNeighbourDelivery', type: 'boolean', label: 'extra_service_no_neighbour_delivery' },
            { name: 'extraServiceHideShipper', type: 'boolean', label: 'extra_service_hide_shipper' },
            { name: 'extraServiceAgeCheck18Plus', type: 'boolean', label: 'extra_service_age_check_18_plus' },
            { name: 'extraServiceSameDayDelivery', type: 'boolean', label: 'extra_service_same_day_delivery' },
            { name: 'extraServiceEveningDelivery', type: 'boolean', label: 'extra_service_evening_delivery' },
            { name: 'extraServiceSaturdayDelivery', type: 'boolean', label: 'extra_service_saturday_delivery' },
            { name: 'extraServiceExpressDeliveryBefore11AM', type: 'boolean', label: 'extra_service_express_delivery_before_11_am' },
            { name: 'extraServiceConstructionSite', type: 'boolean', label: 'extra_service_construction_site' },
            { name: 'extraServiceMessageToRecipient', type: 'boolean', label: 'extra_service_message_to_recipient' },
            { name: 'extraServiceSecureDeliveryByCode', type: 'boolean', label: 'extra_service_secure_delivery_by_code' }   
        ],
        saveObject: {
            accountnumbers: [],
            shipmentType: "",
            deliveryMethod: "",
            extraServiceReference: "",
            extraServiceReturnLabel: false,
            extraServiceTransportInsurance: false,
            extraServiceSignatureOnDelivery: false,
            extraServiceNoNeighbourDelivery: false,
            extraServiceHideShipper: false,
            extraServiceAgeCheck18Plus: false,
            extraServiceSameDayDelivery: false,
            extraServiceEveningDelivery: false,
            extraServiceSaturdayDelivery: false,
            extraServiceExpressDeliveryBefore11AM: false,
            extraServiceConstructionSite: false,
            extraServiceMessageToRecipient: "",
            extraServiceSecureDeliveryByCode: false,
            sizeAndWeight: null,
        }
    },
    cirro: {
        fields: [
            { name: 'includeVATPrepaidService', type: 'boolean', label: 'include_vat_prepaid_service' },
            { name: 'eoriNumber', type: 'text', label: 'eori_number' },
            { name: 'vatNumber', type: 'text', label: 'vat_number' },
            { name: 'iossNumber', type: 'text', label: 'ioss_number' }
        ],
        saveObject: {
            shippingMethod: "",
            includeVATPrepaidService: "",
            eoriNumber: "",
            vatNumber: "",
            iossNumber: ""
        }
    },
    parcel2send: {
        fields: [
            { name: 'shipmentMethod', type: 'dropdown', label: 'shipment_method', options: [
                { label: 'Standaard', value: 'default' },
                { label: 'DPD Home', value: 'dpd_home' },
                { label: 'DPD Home Saturday delivery', value: 'dpd_home_saturday' }
            ] },
            { name: 'insuredAmount', type: 'text', label: 'insured_amount' },
            { name: 'length', type: 'text', label: 'length' },
            { name: 'width', type: 'text', label: 'width' },
            { name: 'height', type: 'text', label: 'height' }
        ],
        saveObject: {
            shipmentMethod: "",
            insuredAmount: "",
            length: "",
            width: "",
            height: ""
        }
    },
    sendcloud: {
        fields: [
            { name: 'multicollo', type: 'boolean', label: 'multicollo' },
            { name: 'useRelationName', type: 'boolean', label: 'use_relation_name' },
            { name: 'insured', type: 'boolean', label: 'insured' },
            { name: 'includeParcelItems', type: 'dropdown', label: 'include_parcel_items', options: [
                { label: 'Only when required for customs', value: 'only_when_required_for_customs' },
                { label: 'Always', value: 'always' }
            ] },
            { name: 'ignoreCustomsDocuments', type: 'boolean', label: 'ignore_customs_documents', tooltip: 'em_ignore_customs_documents' },
            { name: 'useSuggestedCarrierDimensions', type: 'boolean', label: 'use_suggested_carrier_dimensions', tooltip: 'em_use_suggested_carrier_dimensions' },
            { name: 'ignorePhoneCheck', type: 'boolean', label: 'ignore_phone_check', tooltip: 'em_ignore_phone_check' },
        ],
        saveObject: {
            multicollo: false,
            shippingMethod: "",
            senderAddress: "",
            contract: "",
            useRelationName: false,
            insured: false,
            includeParcelItems: "always"
        }
    },
    innosend: {
        fields: [
            { name: 'cycloon_insurance', type: 'boolean', label: 'insurance' },
            { name: 'cycloon_no_neighbour', type: 'boolean', label: 'no_neighbour' },
            { name: 'cycloon_signature_required', type: 'boolean', label: 'signature_required' },
            { name: 'dhl_age_check', type: 'boolean', label: 'age_check' },
            { name: 'dhl_eve_delivery', type: 'boolean', label: 'eve_delivery' },
            { name: 'dhl_insurance', type: 'boolean', label: 'insurance' },
            { name: 'dhl_insured_value', type: 'number', label: 'insured_value' },
            { name: 'dhl_no_neighbour', type: 'boolean', label: 'no_neighbour' },
            { name: 'dhl_saturday_delivery', type: 'boolean', label: 'saturday_delivery' },
            { name: 'dhl_signature', type: 'boolean', label: 'signature' },
            { name: 'dhl_undisclosed_sender', type: 'boolean', label: 'undisclosed_sender' },
            { name: 'fedex_signature', type: 'string', label: 'signature' },
            { name: 'logique_delivery_instructions', type: 'string', label: 'delivery_instructions' },
            { name: 'myparcel_age_check', type: 'boolean', label: 'age_check' },
            { name: 'myparcel_insurance', type: 'number', label: 'insurance' },
            { name: 'myparcel_label_description', type: 'string', label: 'label_description' },
            { name: 'myparcel_large_format', type: 'boolean', label: 'large_format' },
            { name: 'myparcel_no_neighbour', type: 'boolean', label: 'no_neighbour' },
            { name: 'myparcel_return', type: 'boolean', label: 'return' },
            { name: 'myparcel_signature', type: 'boolean', label: 'signature' }
        ],
        saveObject: {
            cycloon_insurance: false,
            cycloon_no_neighbour: false,
            cycloon_signature_required: false,
            dhl_age_check: false,
            dhl_eve_delivery: false,
            dhl_insurance: false,
            dhl_insured_value: 0,
            dhl_no_neighbour: false,
            dhl_saturday_delivery: false,
            dhl_signature: false,
            dhl_undisclosed_sender: false,
            fedex_signature: "",
            logique_delivery_instructions: "",
            myparcel_age_check: false,
            myparcel_insurance: 0,
            myparcel_label_description: "",
            myparcel_large_format: false,
            myparcel_only_recipient: false,
            myparcel_return: false,
            myparcel_signature: false
        }
    },
    innosendv2: {
        // The v2 API routes on a courier plus a shipment type, and the two are chosen together in the
        // shippingMethod dropdown that is filled from the shipper's own Innosend account. The options
        // below are the same per carrier ones v1 offers; the shipper class strips the carrier prefix
        // before sending them on as courier_fields.
        fields: [
            { name: 'cycloon_insurance', type: 'boolean', label: 'insurance' },
            { name: 'cycloon_no_neighbour', type: 'boolean', label: 'no_neighbour' },
            { name: 'cycloon_signature_required', type: 'boolean', label: 'signature_required' },
            { name: 'dhl_age_check', type: 'boolean', label: 'age_check' },
            { name: 'dhl_eve_delivery', type: 'boolean', label: 'eve_delivery' },
            { name: 'dhl_insurance', type: 'boolean', label: 'insurance' },
            { name: 'dhl_insured_value', type: 'number', label: 'insured_value' },
            { name: 'dhl_no_neighbour', type: 'boolean', label: 'no_neighbour' },
            { name: 'dhl_saturday_delivery', type: 'boolean', label: 'saturday_delivery' },
            { name: 'dhl_signature', type: 'boolean', label: 'signature' },
            { name: 'dhl_undisclosed_sender', type: 'boolean', label: 'undisclosed_sender' },
            { name: 'fedex_signature', type: 'string', label: 'signature' },
            { name: 'logique_delivery_instructions', type: 'string', label: 'delivery_instructions' },
            { name: 'myparcel_age_check', type: 'boolean', label: 'age_check' },
            { name: 'myparcel_insurance', type: 'number', label: 'insurance' },
            { name: 'myparcel_label_description', type: 'string', label: 'label_description' },
            { name: 'myparcel_large_format', type: 'boolean', label: 'large_format' },
            { name: 'myparcel_no_neighbour', type: 'boolean', label: 'no_neighbour' },
            { name: 'myparcel_return', type: 'boolean', label: 'return' },
            { name: 'myparcel_signature', type: 'boolean', label: 'signature' }
        ],
        saveObject: {
            cycloon_insurance: false,
            cycloon_no_neighbour: false,
            cycloon_signature_required: false,
            dhl_age_check: false,
            dhl_eve_delivery: false,
            dhl_insurance: false,
            dhl_insured_value: 0,
            dhl_no_neighbour: false,
            dhl_saturday_delivery: false,
            dhl_signature: false,
            dhl_undisclosed_sender: false,
            fedex_signature: "",
            logique_delivery_instructions: "",
            myparcel_age_check: false,
            myparcel_insurance: 0,
            myparcel_label_description: "",
            myparcel_large_format: false,
            myparcel_only_recipient: false,
            myparcel_return: false,
            myparcel_signature: false
        }
    },
    wegrow: {
        // WeGrow picks the carrier itself from the service code, so the method is the only routing
        // decision here. The remaining options map onto WeGrow's value adding services and its
        // customs declaration; HS code and country of origin are mandatory on every cross-border
        // item, so the defaults below cover products that have neither.
        fields: [
            { name: 'shippingMethod', type: 'dropdown', label: 'shipping_method', options: [
                { label: 'Home premium', value: 'wegrow_home_premium' },
                { label: 'Home economy', value: 'wegrow_home_economy' },
                { label: 'Letterbox premium', value: 'wegrow_letterbox_premium' },
                { label: 'Letterbox economy', value: 'wegrow_letterbox_economy' },
                { label: 'Pudo premium', value: 'wegrow_pudo_premium' },
                { label: 'Pudo economy', value: 'wegrow_pudo_economy' },
                { label: 'Postal tracked letterbox', value: 'wegrow_postal_tracked_letterbox' },
                { label: 'Postal tracked parcel', value: 'wegrow_postal_tracked_parcel' },
                { label: 'Postal untracked letterbox', value: 'wegrow_postal_untracked_letterbox' }
            ] },
            { name: 'returnShippingMethod', type: 'dropdown', label: 'return_shipping_method', options: [
                { label: 'Domestic return', value: 'wegrow_domestic_return' },
                { label: 'Direct return', value: 'wegrow_direct_return' }
            ] },
            { name: 'labelFormat', type: 'dropdown', label: 'wegrow_label_format', options: [
                { label: 'PDF', value: 'pdf' },
                { label: 'PNG', value: 'png' },
                { label: 'ZPL 200dpi', value: 'zpl200' },
                { label: 'ZPL 300dpi', value: 'zpl300' }
            ] },
            { name: 'packageType', type: 'dropdown', label: 'wegrow_package_type', options: [
                { label: 'Box', value: 'box' },
                { label: 'Envelope', value: 'envelope' },
                { label: 'Jiffy bag', value: 'jiffy_bag' },
                { label: 'Crate', value: 'crate' },
                { label: 'Pallet', value: 'pallet' },
                { label: 'Wine shipper', value: 'wine_shipper' }
            ] },
            { name: 'serviceSignature', type: 'boolean', label: 'wegrow_service_signature' },
            { name: 'serviceProofOfDelivery', type: 'boolean', label: 'wegrow_service_proof_of_delivery' },
            { name: 'serviceAgeCheck', type: 'boolean', label: 'wegrow_service_age_check' },
            { name: 'minimumAge', type: 'number', label: 'wegrow_minimum_age', conditional: { field: 'serviceAgeCheck', value: true } },
            { name: 'serviceDeliverToNeighbour', type: 'boolean', label: 'wegrow_service_deliver_to_neighbour' },
            { name: 'serviceSafeDrop', type: 'boolean', label: 'wegrow_service_safe_drop' },
            { name: 'serviceMultipleAttempts', type: 'boolean', label: 'wegrow_service_multiple_attempts' },
            { name: 'serviceDisablePreNoticeEmail', type: 'boolean', label: 'wegrow_service_disable_pre_notice_email' },
            { name: 'serviceDisablePreNoticeSms', type: 'boolean', label: 'wegrow_service_disable_pre_notice_sms' },
            { name: 'serviceDisablePreNoticeCall', type: 'boolean', label: 'wegrow_service_disable_pre_notice_call' },
            { name: 'enableInsurance', type: 'boolean', label: 'enable_insurance' },
            { name: 'insuranceAmount', type: 'number', label: 'insurance_amount', conditional: { field: 'enableInsurance', value: true } },
            { name: 'enableCashOnDelivery', type: 'boolean', label: 'wegrow_enable_cash_on_delivery' },
            { name: 'cashOnDeliveryAmount', type: 'number', label: 'wegrow_cash_on_delivery_amount', conditional: { field: 'enableCashOnDelivery', value: true } },
            { name: 'codIban', type: 'text', label: 'wegrow_cod_iban', conditional: { field: 'enableCashOnDelivery', value: true } },
            { name: 'codBic', type: 'text', label: 'wegrow_cod_bic', conditional: { field: 'enableCashOnDelivery', value: true } },
            { name: 'codAccountHolder', type: 'text', label: 'wegrow_cod_account_holder', conditional: { field: 'enableCashOnDelivery', value: true } },
            { name: 'incoterm', type: 'dropdown', label: 'wegrow_incoterm', options: [
                { label: 'DAP', value: 'dap' },
                { label: 'DDP', value: 'ddp' },
                { label: 'DDU', value: 'ddu' },
                { label: 'CIP', value: 'cip' },
                { label: 'CPT', value: 'cpt' },
                { label: 'EXW', value: 'exw' }
            ] },
            { name: 'exportReason', type: 'dropdown', label: 'wegrow_export_reason', options: [
                { label: 'Sale', value: 'sale' },
                { label: 'Sample', value: 'sample' },
                { label: 'Gift', value: 'gift' },
                { label: 'Repair', value: 'repair' },
                { label: 'Warranty', value: 'warranty' },
                { label: 'Document', value: 'document' }
            ] },
            { name: 'dutiesPaidBy', type: 'dropdown', label: 'wegrow_duties_paid_by', options: [
                { label: 'Shipper', value: 'shipper' },
                { label: 'Receiver', value: 'receiver' },
                { label: 'Third party', value: 'third_party' }
            ] },
            { name: 'defaultHsCode', type: 'text', label: 'wegrow_default_hs_code', tooltip: 'wegrow_default_hs_code_tooltip' },
            { name: 'defaultCountryOfOrigin', type: 'text', label: 'wegrow_default_country_of_origin' },
            { name: 'ignorePhoneCheck', type: 'boolean', label: 'ignore_phone_check', tooltip: 'em_ignore_phone_check' },
        ],
        saveObject: {
            shippingMethod: "",
            returnShippingMethod: "",
            labelFormat: "pdf",
            packageType: "box",
            serviceSignature: false,
            serviceProofOfDelivery: false,
            serviceAgeCheck: false,
            minimumAge: "",
            serviceDeliverToNeighbour: false,
            serviceSafeDrop: false,
            serviceMultipleAttempts: false,
            serviceDisablePreNoticeEmail: false,
            serviceDisablePreNoticeSms: false,
            serviceDisablePreNoticeCall: false,
            enableInsurance: false,
            insuranceAmount: "",
            enableCashOnDelivery: false,
            cashOnDeliveryAmount: "",
            codIban: "",
            codBic: "",
            codAccountHolder: "",
            incoterm: "dap",
            exportReason: "sale",
            dutiesPaidBy: "",
            defaultHsCode: "",
            defaultCountryOfOrigin: "NL"
        }
    },
    zineps: {
        // All zineps options come from the configinfo endpoint (account-specific),
        // rendered as dedicated dropdowns in the profile configuration views.
        fields: [
            { name: 'ignorePhoneCheck', type: 'boolean', label: 'ignore_phone_check', tooltip: 'em_ignore_phone_check' }
        ],
        saveObject: {
            shippingMethod: "",
            carrierCode: "",
            carrierContractId: "",
            returnShippingMethod: "",
            senderId: ""
        }
    },
    vinologix: {
        // senderAddress, carrierProduct and returnCarrierProduct come from the configinfo
        // endpoint (account-specific) and are rendered as dedicated dropdowns in the profile
        // configuration views. The static fields below drive those dropdowns: carrier gates the
        // carrier-specific services (and, in the views, filters the product dropdowns).
        fields: [
            { name: 'carrier', type: 'dropdown', label: 'vinologix_carrier', options: [
                { label: 'DPD', value: 'DPD' },
                { label: 'PostNL', value: 'POSTNL' }
            ] },
            { name: 'serviceReturnLabel', type: 'boolean', label: 'vinologix_service_return_label', conditional: { field: 'carrier', value: 'DPD' } },
            { name: 'serviceAgeCheck', type: 'boolean', label: 'vinologix_service_age_check' },
            { name: 'serviceSaturdayDelivery', type: 'boolean', label: 'vinologix_service_saturday_delivery', conditional: { field: 'carrier', value: 'DPD' } },
            { name: 'serviceReturnNotHome', type: 'boolean', label: 'vinologix_service_return_not_home', conditional: { field: 'carrier', value: 'POSTNL' } },
            { name: 'serviceOnlyRecipient', type: 'boolean', label: 'vinologix_service_only_recipient', conditional: { field: 'carrier', value: 'POSTNL' } },
            { name: 'serviceSignature', type: 'boolean', label: 'vinologix_service_signature', conditional: { field: 'carrier', value: 'POSTNL' } },
            { name: 'enableInsurance', type: 'boolean', label: 'enable_insurance' },
            { name: 'insuranceAmount', type: 'number', label: 'insurance_amount', conditional: { field: 'enableInsurance', value: true }, tooltip: 'vinologix_insurance_amount_tooltip' },
            { name: 'reference', type: 'dropdown', label: 'reference', translate: true, options: [
                { label: 'profile_dhl_reference_ordernumber', value: 'order_number' },
                { label: 'profile_dhl_reference_picklistnumber', value: 'picklist_number' },
                { label: 'no', value: 'no' }
            ] },
            { name: 'paperFormat', type: 'dropdown', label: 'vinologix_paper_format', options: [
                { label: 'A6', value: 'A6' },
                { label: 'A4', value: 'A4' }
            ] },
            { name: 'printPosition', type: 'dropdown', label: 'vinologix_print_position', conditional: { field: 'paperFormat', value: 'A4' }, options: [
                { label: 'UPPER_LEFT', value: 'UPPER_LEFT' },
                { label: 'UPPER_RIGHT', value: 'UPPER_RIGHT' },
                { label: 'BOTTOM_LEFT', value: 'BOTTOM_LEFT' },
                { label: 'BOTTOM_RIGHT', value: 'BOTTOM_RIGHT' }
            ] },
        ],
        saveObject: {
            senderAddress: "",
            carrier: "",
            carrierProduct: "",
            returnCarrierProduct: "",
            serviceReturnLabel: false,
            serviceAgeCheck: false,
            serviceSaturdayDelivery: false,
            serviceReturnNotHome: false,
            serviceOnlyRecipient: false,
            serviceSignature: false,
            enableInsurance: false,
            insuranceAmount: "",
            reference: "",
            paperFormat: "A6",
            printPosition: "",
            carrierServices: []
        }
    },
    bol: {
        fields: [
            { name: 'label_type', type: 'dropdown', label: 'bol_use_recommended_label', translate: true, options: [
                { label: 'bol_recommended_label_no', value: 'no' },
                { label: 'bol_recommended_label_bol', value: 'bol' },
                { label: 'bol_recommended_label_stockhub', value: 'stockhub' }
            ] },
            { name: 'only_sameday', type: 'boolean', label: 'bol_only_sameday' },
            { name: 'mailbox_preference', type: 'dropdown', label: 'mailbox_preference', translate:true, options: [
                { label: 'bol_recommended', value: 'recommended' },
                { label: 'bol_always', value: 'always' },
                { label: 'bol_never', value: 'never' }  
            ] },
        ],
        saveObject: {
            label_type: false,
            only_sameday: false,
            mailbox_preference: "",
        }
    },
    ups: {
        fields: [
            { name: 'serviceCode', type: 'dropdown', label: 'ups_service', options: [
                { label: 'UPS Ground', value: '03' },
                { label: 'UPS 3 Day Select', value: '12' },
                { label: 'UPS 2nd Day Air', value: '02' },
                { label: 'UPS 2nd Day Air A.M.', value: '59' },
                { label: 'UPS Next Day Air Saver', value: '13' },
                { label: 'UPS Next Day Air', value: '01' },
                { label: 'UPS Next Day Air Early', value: '14' },
                { label: 'UPS Standard', value: '11' },
                { label: 'UPS Worldwide Express', value: '07' },
                { label: 'UPS Worldwide Express Plus', value: '54' },
                { label: 'UPS Worldwide Expedited', value: '08' },
                { label: 'UPS Worldwide Saver', value: '65' }
            ] },
            { name: 'packageType', type: 'dropdown', label: 'package_type', options: [
                { label: 'Customer Supplied Package', value: '02' },
                { label: 'UPS Letter', value: '01' },
                { label: 'UPS Tube', value: '03' },
                { label: 'UPS Pak', value: '04' },
                { label: 'UPS Express Box', value: '21' },
                { label: 'UPS 25KG Box', value: '24' },
                { label: 'UPS 10KG Box', value: '25' }
            ] },
            { name: 'deliveryConfirmation', type: 'dropdown', label: 'delivery_confirmation', options: [
                { label: 'None', value: '0' },
                { label: 'Delivery Confirmation', value: '1' },
                { label: 'Signature Required', value: '2' },
                { label: 'Adult Signature Required', value: '3' }
            ] },
            { name: 'saturdayDelivery', type: 'boolean', label: 'saturday_delivery' },
            { name: 'pickupType', type: 'dropdown', label: 'pickup_type', options: [
                { label: 'Daily Pickup', value: '01' },
                { label: 'Customer Counter', value: '03' },
                { label: 'One Time Pickup', value: '06' },
                { label: 'On Call Air', value: '07' },
                { label: 'Letter Center', value: '19' },
                { label: 'Air Service Center', value: '20' }
            ] },
            { name: 'includeOrderReference', type: 'boolean', label: 'include_order_reference' },
            { name: 'includeCustomerReference', type: 'boolean', label: 'include_customer_reference' },
            { name: 'billShipping', type: 'dropdown', label: 'bill_shipping_to', options: [
                { label: 'Sender (Default)', value: 'sender' },
                { label: 'Receiver', value: 'receiver' },
                { label: 'Third Party', value: 'third_party' }
            ] },
            { name: 'thirdPartyAccountNumber', type: 'text', label: 'third_party_account_number' },
            { name: 'enableInsurance', type: 'boolean', label: 'enable_insurance' },
            { name: 'insuranceValue', type: 'text', label: 'insurance_value' },
            { name: 'customsDescription', type: 'text', label: 'customs_description' },
            { name: 'dutyPayment', type: 'dropdown', label: 'duty_payment', options: [
                { label: 'Sender', value: 'sender' },
                { label: 'Receiver', value: 'receiver' },
                { label: 'Third Party', value: 'third_party' }
            ] },
            { name: 'emailNotifications', type: 'boolean', label: 'email_notifications' },
            { name: 'smsNotifications', type: 'boolean', label: 'sms_notifications' },
            { name: 'carbonNeutral', type: 'boolean', label: 'carbon_neutral_shipping' }
        ],
        saveObject: {
            serviceCode: "",
            packageType: "02",
            deliveryConfirmation: "0",
            saturdayDelivery: false,
            pickupType: "01",
            includeOrderReference: true,
            includeCustomerReference: false,
            labelFormat: "PDF",
            billShipping: "sender",
            thirdPartyAccountNumber: "",
            enableInsurance: false,
            insuranceValue: "",
            customsDescription: "Commercial goods",
            dutyPayment: "sender",
            emailNotifications: false,
            smsNotifications: false,
            carbonNeutral: false
        }        
    },
    dhlgermany: {
        fields: [
            // Business Configuration
            { 
                name: 'billingNumber', 
                type: 'text', 
                label: 'billing_number',
                validation: 'required',
                helpText: 'dhl_germany_billing_number_help',
                placeholder: 'XXXXXXXXXX01XX'
            },
            
            { 
                name: 'profile', 
                type: 'text', 
                label: 'profile',
                default: 'STANDARD_GRUPPENPROFIL',
                helpText: 'dhl_germany_profile_help'
            },
            
            // Service Configuration
            { 
                name: 'serviceType', 
                type: 'dropdown', 
                label: 'service_type', 
                options: [
                    { label: 'DHL Paket', value: 'V01PAK' },
                    { label: 'DHL Paket International', value: 'V53WPAK' },
                    { label: 'DHL Europaket', value: 'V54EPAK' },
                    { label: 'DHL Kleinpaket', value: 'V62KP' },
                    { label: 'DHL Warenpost International', value: 'V66WPI' }
                ],
                default: 'auto',
                helpText: 'dhl_germany_service_type_help'
            },
            
            { 
                name: 'preferWarenpost', 
                type: 'boolean', 
                label: 'prefer_warenpost_when_possible',
                conditional: { field: 'serviceType', value: 'auto' },
                default: false,
                helpText: 'dhl_germany_prefer_warenpost_help'
            },
            
            // Reference Configuration
            { 
                name: 'referenceType', 
                type: 'dropdown', 
                label: 'reference_type', 
                options: [
                    { label: 'order_number', value: 'order_number' },
                    { label: 'picklist_number', value: 'picklist_number' },
                    { label: 'custom_reference', value: 'custom' },
                    { label: 'no_reference', value: 'no' }
                ],
                default: 'order_number',
                helpText: 'dhl_reference_type_help'
            },
            
            { 
                name: 'customReference', 
                type: 'text', 
                label: 'custom_reference_text',
                conditional: { field: 'referenceType', value: 'custom' },
                maxLength: 35
            },
            
            // Delivery Preferences
            { 
                name: 'preferredNeighbour', 
                type: 'boolean', 
                label: 'preferred_neighbour',
                default: false,
                helpText: 'dhl_germany_preferred_neighbour_help'
            },
            
            { 
                name: 'preferredNeighbourText', 
                type: 'text', 
                label: 'preferred_neighbour_instructions',
                conditional: { field: 'preferredNeighbour', value: true },
                maxLength: 100
            },
            
            { 
                name: 'preferredLocation', 
                type: 'boolean', 
                label: 'preferred_location',
                default: false,
                helpText: 'dhl_germany_preferred_location_help'
            },
            
            { 
                name: 'preferredLocationText', 
                type: 'text', 
                label: 'preferred_location_instructions',
                conditional: { field: 'preferredLocation', value: true },
                maxLength: 100
            },
            
            // Signature & Identity Services
            { 
                name: 'signedForByRecipient', 
                type: 'boolean', 
                label: 'signature_required',
                default: false,
                helpText: 'dhl_germany_signature_help'
            },
            
            { 
                name: 'namedPersonOnly', 
                type: 'boolean', 
                label: 'named_person_only',
                default: false,
                helpText: 'dhl_germany_named_person_help'
            },
            
            { 
                name: 'noNeighbourDelivery', 
                type: 'boolean', 
                label: 'no_neighbour_delivery',
                default: false,
                helpText: 'dhl_germany_no_neighbour_help'
            },
            
            // Age Verification
            { 
                name: 'visualCheckOfAge', 
                type: 'dropdown', 
                label: 'age_verification', 
                translate: true,
                options: [
                    { label: 'no_age_check', value: '' },
                    { label: 'age_16_plus', value: 'A16' },
                    { label: 'age_18_plus', value: 'A18' }
                ],
                default: '',
                helpText: 'dhl_germany_age_check_help'
            },
            
            { 
                name: 'identCheck', 
                type: 'boolean', 
                label: 'ident_check',
                default: false,
                helpText: 'dhl_germany_ident_check_help'
            },
            
            { 
                name: 'identCheckMinAge', 
                type: 'dropdown', 
                label: 'ident_check_min_age',
                conditional: { field: 'identCheck', value: true },
                options: [
                    { label: 'age_16_plus', value: 'A16' },
                    { label: 'age_18_plus', value: 'A18' }
                ],
                default: 'A18'
            },
            
            // Insurance
            { 
                name: 'additionalInsurance', 
                type: 'boolean', 
                label: 'additional_insurance',
                default: false,
                helpText: 'dhl_germany_insurance_help'
            },
            
            { 
                name: 'insuranceValue', 
                type: 'number', 
                label: 'insurance_value_eur',
                conditional: { field: 'additionalInsurance', value: true },
                min: 0,
                max: 25000,
                step: 0.01,
                default: 500
            },
            
            { 
                name: 'insuranceCurrency', 
                type: 'dropdown', 
                label: 'insurance_currency',
                conditional: { field: 'additionalInsurance', value: true },
                options: [
                    { label: 'EUR', value: 'EUR' },
                    { label: 'CHF', value: 'CHF' }
                ],
                default: 'EUR'
            },        
            { 
                name: 'bulkyGoods', 
                type: 'boolean', 
                label: 'bulky_goods',
                default: false,
                helpText: 'dhl_germany_bulky_goods_help'
            },
            
            // Return Label
            { 
                name: 'includeReturnLabel', 
                type: 'boolean', 
                label: 'include_return_label',
                default: false,
                helpText: 'dhl_germany_return_label_help'
            },
            
            { 
                name: 'returnBillingNumber', 
                type: 'text', 
                label: 'return_billing_number',
                conditional: { field: 'includeReturnLabel', value: true },
                helpText: 'dhl_germany_return_billing_help'
            },
            
            // International Options
            { 
                name: 'endorsement', 
                type: 'dropdown', 
                label: 'undeliverable_handling', 
                translate: true,
                options: [
                    { label: 'no_preference', value: '' },
                    { label: 'return_to_sender', value: 'RETURN' },
                    { label: 'abandon', value: 'ABANDON' }
                ],
                default: '',
                helpText: 'dhl_germany_endorsement_help'
            },
            
            { 
                name: 'postalDeliveryDutyPaid', 
                type: 'boolean', 
                label: 'postal_delivery_duty_paid',
                default: false,
                helpText: 'dhl_germany_pddp_help'
            },
            
            // Fallback Delivery
            { 
                name: 'closestDropPoint', 
                type: 'boolean', 
                label: 'closest_drop_point',
                default: false,
                helpText: 'dhl_germany_cdp_help'
            },
            
            { 
                name: 'parcelOutletRouting', 
                type: 'boolean', 
                label: 'parcel_outlet_routing',
                default: false,
                helpText: 'dhl_germany_outlet_routing_help'
            },
            
            // Cash on Delivery
            { 
                name: 'cashOnDelivery', 
                type: 'boolean', 
                label: 'cash_on_delivery',
                default: false,
                helpText: 'dhl_germany_cod_help'
            },
            
            { 
                name: 'codAccountHolder', 
                type: 'text', 
                label: 'cod_account_holder',
                conditional: { field: 'cashOnDelivery', value: true },
                maxLength: 80
            },
            
            { 
                name: 'codIban', 
                type: 'text', 
                label: 'cod_iban',
                conditional: { field: 'cashOnDelivery', value: true },
                maxLength: 34
            },
            
            { 
                name: 'codBic', 
                type: 'text', 
                label: 'cod_bic',
                conditional: { field: 'cashOnDelivery', value: true },
                maxLength: 11
            },
            
            // Warenpost Size Limits Info
            { 
                name: 'warenpostLimitsDisplay', 
                type: 'info', 
                label: 'warenpost_size_limits',
                conditional: { field: 'serviceType', value: ['V62KP', 'V66WPI'] },
                content: {
                    maxWeight: '1,000g',
                    maxDimensions: '35.3 x 25.0 x 5.0 cm',
                    minDimensions: "-"
                }
            }
        ],
        saveObject: {
            billingNumber: "",
            profile: "STANDARD_GRUPPENPROFIL",
            serviceType: "auto",
            preferWarenpost: false,
            referenceType: "order_number",
            customReference: "",
            preferredNeighbour: false,
            preferredNeighbourText: "",
            preferredLocation: false,
            preferredLocationText: "",
            signedForByRecipient: false,
            namedPersonOnly: false,
            noNeighbourDelivery: false,
            visualCheckOfAge: "",
            identCheck: false,
            identCheckMinAge: "A18",
            additionalInsurance: false,
            insuranceValue: 500,
            insuranceCurrency: "EUR",
            premium: false,
            bulkyGoods: false,
            includeReturnLabel: false,
            returnBillingNumber: "",
            endorsement: "",
            postalDeliveryDutyPaid: false,
            closestDropPoint: false,
            parcelOutletRouting: false,
            cashOnDelivery: false,
            codAccountHolder: "",
            codIban: "",
            codBic: ""
        }
    },
    intrapost: {
        fields: [
            { name: 'product', type: 'dropdown', label: 'product', translate: true, options: [
                { label: 'intrapost_standard_parcel', value: '1' },
                { label: 'intrapost_insured_parcel', value: '2' },
                { label: 'intrapost_registered_parcel', value: '3' },
                { label: 'intrapost_insured_letter', value: '4' },
                { label: 'intrapost_registered_letter', value: '5' },
                { label: 'intrapost_standard_parcel_stated_address', value: '6' },
                { label: 'intrapost_standard_parcel_stated_address_signature', value: '7' },
                { label: 'intrapost_mailbox_parcel', value: '8' },
                { label: 'intrapost_parcel_via_pickup_location', value: '9' },
                { label: 'intrapost_standard_parcel_evening_delivery', value: '10' },
                { label: 'intrapost_standard_parcel_age_check', value: '11' },
                { label: 'intrapost_standard_parcel_signature', value: '12' }
            ] },
            { name: 'sendMailToRecipient', type: 'boolean', label: 'send_mail_to_recipient' }
        ],
        saveObject: {
            product: "",
            sendMailToRecipient: false
        }
    },
    myparcel: {
        fields: [
            // Carrier Configuration
            { 
                name: 'defaultCarrier', 
                type: 'dropdown', 
                label: 'default_shipping_carrier', 
                options: [
                    { label: 'PostNL', value: 1 },
                    { label: 'bpost', value: 2 },
                    { label: 'DPD', value: 3 },
                    { label: 'Auto-detect', value: 'auto' }
                ],
                default: 1,
                helpText: 'myparcel_carrier_help'
            },

            // Package Type Configuration
            { 
                name: 'packageType', 
                type: 'dropdown', 
                label: 'package_type', 
                options: [
                    { label: 'Package', value: 1 },
                    { label: 'Mailbox package', value: 2 },
                    { label: 'Letter', value: 3 },
                    { label: 'Digital stamp', value: 4 },
                    { label: 'Pallet', value: 5 },
                    { label: 'Small package', value: 6 },
                    { label: 'Envelope', value: 7 }
                ],
                default: 1,
                helpText: 'myparcel_package_type_help'
            },

            // Delivery Options
            { 
                name: 'deliveryType', 
                type: 'dropdown', 
                label: 'delivery_type', 
                options: [
                    { label: 'Standard delivery', value: 1 },
                    { label: 'Morning delivery', value: 2 },
                    { label: 'Evening delivery', value: 3 },
                    { label: 'Pickup point', value: 4 }
                ],
                default: 1,
                helpText: 'myparcel_delivery_type_help'
            },

            // Reference Configuration
            { 
                name: 'referenceType', 
                type: 'dropdown', 
                label: 'reference_identifier', 
                options: [
                    { label: 'Order number', value: 'order_number' },
                    { label: 'Order barcode', value: 'order_barcode' },
                    { label: 'Customer reference', value: 'customer_reference' }
                    // { label: 'Custom format', value: 'custom' }
                ],
                default: 'order_number',
                helpText: 'myparcel_reference_help'
            },

            // Weight and Dimension Handling
            { 
                name: 'minPackageWeight', 
                type: 'number', 
                label: 'minimum_package_weight_grams',
                min: 0,
                max: 30000,
                default: 50,
                helpText: 'myparcel_min_weight_help'
            },
            // International Shipping
            { 
                name: 'customsDescription', 
                type: 'text', 
                label: 'customs_description',
                default: 'Commercial goods',
                maxLength: 100,
                helpText: 'myparcel_customs_description_help'
            },
            

            // Service Options
            { 
                name: 'signatureRequired', 
                type: 'boolean', 
                label: 'signature_required',
                default: false,
                helpText: 'myparcel_signature_help'
            },

            { 
                name: 'onlyRecipient', 
                type: 'boolean', 
                label: 'only_recipient_delivery',
                default: false,
                helpText: 'myparcel_only_recipient_help'
            },

            { 
                name: 'ageCheck', 
                type: 'boolean', 
                label: 'age_verification',
                default: false,
            },

            { 
                name: 'largeFormat', 
                type: 'boolean', 
                label: 'large_format_package',
                default: false,
            },

            // { 
            //     name: 'returnOption', 
            //     type: 'boolean', 
            //     label: 'include_return_option',
            //     default: false,
            //     helpText: 'myparcel_return_option_help'
            // },

            // Insurance Configuration
            { 
                name: 'enableInsurance', 
                type: 'boolean', 
                label: 'enable_insurance',
                default: false,
            },

            { 
                name: 'insuranceAmount', 
                type: 'dropdown', 
                label: 'insurance_amount', 
                options: [
                    { label: '€50', value: 50 },
                    { label: '€250', value: 250 },
                    { label: '€500', value: 500 },
                    { label: '€1000', value: 1000 },
                    { label: '€1500', value: 1500 },
                    { label: '€2000', value: 2000 },
                    { label: '€2500', value: 2500 }
                ],
                conditional: { field: 'enableInsurance', value: true },
                default: 250
            },

            // // Label Configuration
            // { 
            //     name: 'labelFormat', 
            //     type: 'dropdown', 
            //     label: 'label_format', 
            //     options: [
            //         { label: 'PDF A4', value: 'A4' },
            //         { label: 'PDF A6', value: 'A6' },
            //         { label: 'ZPL (thermal)', value: 'ZPL' }
            //     ],
            //     default: 'A4',
            //     helpText: 'myparcel_label_format_help'
            // },

            // { 
            //     name: 'labelPosition', 
            //     type: 'dropdown', 
            //     label: 'label_position', 
            //     options: [
            //         { label: 'Top Left', value: 1 },
            //         { label: 'Top Right', value: 2 },
            //         { label: 'Bottom Left', value: 3 },
            //         { label: 'Bottom Right', value: 4 }
            //     ],
            //     conditional: { field: 'labelFormat', value: 'A4' },
            //     default: 1,
            //     helpText: 'myparcel_label_position_help'
            // },

            

            // { 
            //     name: 'customReferenceFormat', 
            //     type: 'text', 
            //     label: 'custom_reference_format',
            //     conditional: { field: 'referenceType', value: 'custom' },
            //     placeholder: 'e.g. ORD-{order_id}',
            //     maxLength: 50,
            //     helpText: 'myparcel_custom_reference_help'
            // },

            // Multi-collo Configuration
            { 
                name: 'enableMultiCollo', 
                type: 'boolean', 
                label: 'enable_multi_collo',
                default: false,
            },

            { 
                name: 'maxPackagesPerShipment', 
                type: 'number', 
                label: 'max_packages_per_shipment',
                conditional: { field: 'enableMultiCollo', value: true },
                min: 1,
                max: 10,
                default: 3,
            },

            // Special Delivery Days
            { 
                name: 'allowSaturdayDelivery', 
                type: 'boolean', 
                label: 'allow_saturday_delivery',
                default: false,
            },

            { 
                name: 'allowMondayDelivery', 
                type: 'boolean', 
                label: 'allow_monday_delivery',
                default: true,
            }

            // // Return Shipment Configuration
            // { 
            //     name: 'returnCarrier', 
            //     type: 'dropdown', 
            //     label: 'return_carrier', 
            //     options: [
            //         { label: 'Same as outbound', value: 'same' },
            //         { label: 'PostNL', value: 1 },
            //         { label: 'bpost', value: 2 },
            //         { label: 'DPD', value: 3 }
            //     ],
            //     default: 'same',
            //     helpText: 'myparcel_return_carrier_help'
            // },

            // { 
            //     name: 'returnPackageType', 
            //     type: 'dropdown', 
            //     label: 'return_package_type', 
            //     options: [
            //         { label: 'Same as outbound', value: 'same' },
            //         { label: 'Package', value: 1 },
            //         { label: 'Mailbox package', value: 2 },
            //         { label: 'Letter', value: 3 }
            //     ],
            //     default: 'same',
            //     helpText: 'myparcel_return_package_type_help'
            // },

            

            // { 
            //     name: 'includeInvoiceInShipment', 
            //     type: 'boolean', 
            //     label: 'include_invoice_in_shipment',
            //     default: false,
            //     helpText: 'myparcel_include_invoice_help'
            // },

            

            // { 
            //     name: 'autoDetectPackageType', 
            //     type: 'boolean', 
            //     label: 'auto_detect_package_type',
            //     default: true,
            //     helpText: 'myparcel_auto_detect_help'
            // }
        ],
        
        saveObject: {
            defaultCarrier: 1,
            packageType: 1,
            deliveryType: 1,
            signatureRequired: false,
            onlyRecipient: false,
            ageCheck: false,
            largeFormat: false,
            //returnOption: false,
            enableInsurance: false,
            insuranceAmount: 250,
            labelFormat: "A4",
            labelPosition: 1,
            referenceType: "order_number",
            // customReferenceFormat: "",
            enableMultiCollo: false,
            maxPackagesPerShipment: 3,
            allowSaturdayDelivery: false,
            allowMondayDelivery: true,
            // returnCarrier: "same",
            // returnPackageType: "same",
            customsDescription: "Commercial goods",
            //includeInvoiceInShipment: false,
            minPackageWeight: 50,
            //autoDetectPackageType: true
        },

        // Validation rules for different configurations
        validationRules: {
            packageTypeCompatibility: {
                // Some delivery types not available for all package types
                mailboxPackage: {
                    disabledDeliveryTypes: [2, 3], // No morning/evening for mailbox
                    maxDimensions: { length: 380, width: 265, height: 32 },
                    maxWeight: 2000
                },
                letter: {
                    disabledDeliveryTypes: [2, 3, 4], // Only standard delivery
                    maxWeight: 2000,
                    disabledOptions: ['signatureRequired', 'onlyRecipient']
                },
                digitalStamp: {
                    maxWeight: 2000,
                    disabledOptions: ['signatureRequired', 'onlyRecipient', 'ageCheck']
                }
            },
            
            carrierCompatibility: {
                bpost: {
                    supportedCountries: ['BE', 'LU'],
                    disabledPackageTypes: [4], // No digital stamp
                },
                dpd: {
                    supportedCountries: ['NL', 'BE', 'DE', 'FR', 'LU'],
                    requiredServices: ['signatureRequired'] // DPD requires signature
                }
            }
        },

        // Package type limits for auto-detection
        packageLimits: {
            mailboxPackage: {
                maxLengthMm: 380,
                maxWidthMm: 265,
                maxHeightMm: 32,
                maxWeightG: 2000
            },
            letter: {
                maxLengthMm: 380,
                maxWidthMm: 265,
                maxHeightMm: 32,
                maxWeightG: 2000,
                requiresFlatShape: true
            },
            standardPackage: {
                maxWeightG: 30000,
                maxLengthMm: 1000,
                maxWidthMm: 500,
                maxHeightMm: 500
            }
        }
    },
    gls: {
      fields: [
          // Authentication Configuration
          

          // Service Configuration
          {
              name: 'serviceType',
              type: 'dropdown',
              label: 'gls_service_type',
              translate: true,
              options: [
                  { label: 'gls_service_standard', value:  'standard' },
                  { label: 'gls_service_express', value:  'express' },
                  { label: 'gls_service_economy', value:  'economy' },
                  { label: 'gls_service_business', value:  'business' }
              ],
              default: 'standard',
              helpText: 'gls_service_type_help'
          },
          // Shipment type shipment_type
          {
              name: 'shipmentType',
              type: 'dropdown',
              label: 'shipment_type',
              translate: true,
              options: [
                  { label: 'parcel', value:  'parcel' },
                  { label: 'pallet', value:  'pallet' },
              ],
              default: 'parcel',
          },

          // Insurance Configuration
          {
              name: 'insurance',
              type: 'boolean',
              label: 'gls_enable_insurance',
              default: false,
              helpText: 'gls_insurance_help'
          },

          {
              name: 'insuranceAmount',
              type: 'number',
              label: 'gls_insurance_amount_eur',
              conditional: { field: 'insurance', value: true },
              min: 0,
              max: 10000,
              step: 0.01,
              default: 0,
              helpText: 'gls_insurance_amount_help'
          },

          // Delivery Options
          {
              name: 'signatureRequired',
              type: 'boolean',
              label: 'gls_signature_required',
              default: false,
              helpText: 'gls_signature_help'
          },
          // Return label
          {
              name: 'shopReturnService',
              type: 'boolean',
              label: 'gls_include_return_label',
              default: false,
              helpText: 'gls_include_return_label_help'
          },
          {
              name: 'deliveryNotification',
              type: 'boolean',
              label: 'gls_delivery_notification',
              default: true,
              helpText: 'gls_delivery_notification_help'
          },
          {
            name: 'saturdayDelivery',
            type: 'boolean',
            label: 'gls_saturday_delivery',
            default: false,
        },
          {
            name: 'letterBoxDelivery',
            type: 'boolean',
            label: 'gls_letterbox_parcel',
            default: false,
            helpText: 'gls_letterbox_parcel_help'
        },

          {
              name: 'smsNotification',
              type: 'boolean',
              label: 'gls_sms_notification',
              conditional: { field: 'deliveryNotification',
  value: true },
              default: false,
              helpText: 'gls_sms_notification_help'
          },

          // Minimum weight (grams) and dimensions (cm) for units without product data, so GLS does not reject them
          {
              name: 'useMinimums',
              type: 'boolean',
              label: 'gls_use_minimums',
              default: false,
              helpText: 'gls_use_minimums_help'
          },
          {
              name: 'minWeight',
              type: 'number',
              label: 'minimum_package_weight_grams',
              conditional: { field: 'useMinimums', value: true },
              min: 0,
              max: 30000,
              step: 1,
              default: 100
          },
          {
              name: 'minLength',
              type: 'number',
              label: 'gls_min_length_cm',
              conditional: { field: 'useMinimums', value: true },
              min: 0,
              max: 200,
              step: 1,
              default: 10
          },
          {
              name: 'minWidth',
              type: 'number',
              label: 'gls_min_width_cm',
              conditional: { field: 'useMinimums', value: true },
              min: 0,
              max: 80,
              step: 1,
              default: 5
          },
          {
              name: 'minHeight',
              type: 'number',
              label: 'gls_min_height_cm',
              conditional: { field: 'useMinimums', value: true },
              min: 0,
              max: 60,
              step: 1,
              default: 2
          }
      ],
      saveObject: {
          serviceType: "standard",
          insurance: false,
          insuranceAmount: 0,
          signatureRequired: false,
          deliveryNotification: true,
          smsNotification: false,
          letterBoxDelivery: false,
          useMinimums: false,
          minWeight: 100,
          minLength: 10,
          minWidth: 5,
          minHeight: 2,
      },
  },
  trunkrs: {
    fields: [
        { 
            name: 'serviceType', 
            type: 'dropdown', 
            label: 'service_type', 
            options: [
                { label: 'Same Day Delivery', value: 'SAME_DAY' },
                { label: 'Same Day Frozen Food', value: 'SAME_DAY_FROZEN_FOOD' }
            ],
            default: 'SAME_DAY'
        },
        { 
            name: 'noNeighbourDelivery', 
            type: 'boolean', 
            label: 'no_neighbour_delivery',
            default: false,
            helpText: 'Prevent delivery to neighbors (additional costs apply)'
        },
        { 
            name: 'requireSignature', 
            type: 'boolean', 
            label: 'require_signature',
            default: false
        },
        { 
            name: 'requireAgeCheck', 
            type: 'boolean', 
            label: 'require_age_check',
            default: false
        },
        { 
            name: 'requireProofOfDelivery', 
            type: 'boolean', 
            label: 'require_proof_of_delivery',
            default: false,
            helpText: 'Strict proof of delivery (additional costs apply)'
        },
        { 
            name: 'deliverInMailBox', 
            type: 'boolean', 
            label: 'allow_mailbox_delivery',
            default: false
        },
        { 
            name: 'maxDeliveryAttempts', 
            type: 'number', 
            label: 'max_delivery_attempts',
            min: 1,
            max: 3,
            default: 3
        },
        { 
            name: 'maxTimeOutsideFreezer', 
            type: 'number', 
            label: 'max_time_outside_freezer_hours',
            conditional: { field: 'serviceType', value: ['SAME_DAY_FROZEN_FOOD'] },
            min: 10,
            max: 30,
            default: 15,
            helpText: 'Maximum cumulative time outside freezer before return required'
        }
    ],
    saveObject: {
        serviceType: "SAME_DAY",
        noNeighbourDelivery: false,
        requireSignature: false,
        requireAgeCheck: false,
        requireProofOfDelivery: false,
        deliverInMailBox: false,
        maxDeliveryAttempts: 3,
        maxTimeOutsideFreezer: 15
    }
},
  cycloon: {
    fields: [
        {
            name: 'deliveryType',
            type: 'dropdown',
            label: 'delivery_type',
            options: [
                { label: 'Same Day', value: '1' },
                { label: 'Next Day', value: '2' }
            ],
            default: '1'
        },
        {
            name: 'product',
            type: 'dropdown',
            label: 'product',
            options: [
                { label: 'Pakket', value: '1' },
                { label: 'Pakket XL', value: '2' },
                { label: 'Brievenbuspakket', value: '3'},
                { label: 'Aangetekende brief', value: '4'},
                { label: 'Aangetekend pakket', value: '5'}
            ],
            default: '1'
        },
        {
            name: 'noNeighbourDelivery',
            type: 'boolean',
            label: 'no_neighbour_delivery',
            default: false,
            helpText: 'Prevent delivery to neighbors (additional costs apply)'
        },
        {
            name: 'requireSignature',
            type: 'boolean',
            label: 'require_signature',
            default: false
        }
    ],
    saveObject: {
        serviceType: "SAME_DAY",
        noNeighbourDelivery: false,
        requireSignature: false,
        requireAgeCheck: false,
        requireProofOfDelivery: false,
        deliverInMailBox: false,
        maxDeliveryAttempts: 3,
        maxTimeOutsideFreezer: 15
    }
},
myparcelcom: {
    fields: [
        // ==================== SERVICE CONFIGURATION ====================
        // {
        //     name: 'serviceType',
        //     type: 'dropdown',
        //     label: 'myparcelcom_service_type',
        //     options: 'DYNAMIC', // Fetched from getConfigInfo()
        //     required: true,
        //     helpText: 'myparcelcom_service_type_help'
        // },

        // {
        //     name: 'carrier',
        //     type: 'dropdown',
        //     label: 'myparcelcom_carrier',
        //     options: 'DYNAMIC', // Fetched from getConfigInfo()
        //     required: false,
        //     helpText: 'myparcelcom_carrier_help'
        // },

        // {
        //     name: 'contractId',
        //     type: 'dropdown',
        //     label: 'myparcelcom_contract',
        //     options: 'DYNAMIC', // Fetched from getConfigInfo()
        //     required: false,
        //     helpText: 'myparcelcom_contract_help'
        // },

        // ==================== PACKAGE CONFIGURATION ====================
        {
            name: 'packageType',
            type: 'dropdown',
            label: 'myparcelcom_package_type',

            translate: true,
            options: [
                { label: 'myparcelcom_package_standard', value: 'package' },
                { label: 'myparcelcom_package_envelope', value: 'envelope' },
                { label: 'myparcelcom_package_pallet', value: 'pallet' },
                { label: 'myparcelcom_package_letter', value: 'letter' }
            ],
            default: 'package',
            helpText: 'myparcelcom_package_type_help'
        },

        {
            name: 'minPackageWeight',
            type: 'number',
            label: 'myparcelcom_min_weight_grams',
            min: 0,
            max: 30000,
            default: 50,
            helpText: 'myparcelcom_min_weight_help'
        },

        // ==================== DELIVERY OPTIONS ====================
        {
            name: 'signatureRequired',
            type: 'boolean',
            label: 'myparcelcom_signature_required',
            default: false,
            helpText: 'myparcelcom_signature_help'
        },

        {
            name: 'onlyRecipient',
            type: 'boolean',
            label: 'myparcelcom_only_recipient',
            default: false,
            helpText: 'myparcelcom_only_recipient_help'
        },

        {
            name: 'ageVerification',
            type: 'boolean',
            label: 'myparcelcom_age_verification_18',
            default: false,
            helpText: 'myparcelcom_age_verification_help'
        },

        {
            name: 'deliveryType',
            type: 'dropdown',
            label: 'myparcelcom_delivery_type',
            options: [
                { label: 'myparcelcom_delivery_standard', value: 'standard' },
                { label: 'myparcelcom_delivery_morning', value: 'morning' },
                { label: 'myparcelcom_delivery_evening', value: 'evening' },
                { label: 'myparcelcom_delivery_pickup', value: 'pickup' }
            ],
            default: 'standard',
            helpText: 'myparcelcom_delivery_type_help'
        },

        // ==================== INSURANCE ====================
        {
            name: 'enableInsurance',
            type: 'boolean',
            label: 'myparcelcom_enable_insurance',
            default: false,
            helpText: 'myparcelcom_insurance_help'
        },

        {
            name: 'insuranceAmount',
            type: 'dropdown',
            label: 'myparcelcom_insurance_amount_eur',
            conditional: { field: 'enableInsurance', value: true },
            options: [
                { label: '€50', value: 50 },
                { label: '€100', value: 100 },
                { label: '€250', value: 250 },
                { label: '€500', value: 500 },
                { label: '€1,000', value: 1000 },
                { label: '€1,500', value: 1500 },
                { label: '€2,000', value: 2000 },
                { label: '€2,500', value: 2500 }
            ],
            default: 50,
            helpText: 'myparcelcom_insurance_amount_help'
        },

        // ==================== LABEL CONFIGURATION ====================
        {
            name: 'labelFormat',
            type: 'dropdown',
            label: 'myparcelcom_label_format',
            options: [
                { label: 'myparcelcom_label_pdf_a6', value: 'A6' },
                { label: 'myparcelcom_label_zpl', value: 'ZPL' }
            ],
            default: 'A6',
            helpText: 'myparcelcom_label_format_help'
        },
        // ==================== MULTI-COLLO ====================
        {
            name: 'enableMultiCollo',
            type: 'boolean',
            label: 'myparcelcom_enable_multi_collo',
            default: false,
            helpText: 'myparcelcom_multi_collo_help'
        },

        {
            name: 'maxPackagesPerShipment',
            type: 'number',
            label: 'myparcelcom_max_packages',
            conditional: { field: 'enableMultiCollo', value: true },
            min: 1,
            max: 10,
            default: 3,
            helpText: 'myparcelcom_max_packages_help'
        },
        // ==================== CUSTOMS ====================
        {
            name: 'includeCustomsInfo',
            type: 'dropdown',
            label: 'myparcelcom_customs_info',
            options: [
                { label: 'myparcelcom_customs_non_eu_only', value: 'non_eu_only' },
                { label: 'myparcelcom_customs_always', value: 'always' },
                { label: 'myparcelcom_customs_never', value: 'never' }
            ],
            default: 'non_eu_only',
            helpText: 'myparcelcom_customs_info_help'
        },

        {
            name: 'customsDescription',
            type: 'text',
            label: 'myparcelcom_customs_description',
            conditional: { field: 'includeCustomsInfo', value: ['non_eu_only', 'always'] },
            maxLength: 100,
            placeholder: 'Commercial goods',
            helpText: 'myparcelcom_customs_description_help'
        }
    ],

    saveObject: {
        serviceType: "",
        carrier: "",
        contractId: "",
        packageType: "package",
        minPackageWeight: 50,
        signatureRequired: false,
        onlyRecipient: false,
        ageVerification: false,
        deliveryType: "standard",
        enableInsurance: false,
        insuranceAmount: 50,
        labelFormat: "A6",
        labelPosition: 1,
        enableMultiCollo: false,
        maxPackagesPerShipment: 3,
        returnServiceType: "",
        returnSignatureRequired: false,
        includeCustomsInfo: "non_eu_only",
        customsDescription: ""
    }
},
hst: {
    fields: [
        // Pluscode Selection (filtered by destination)
        {
            name: 'pluscodes',
            type: 'multidropdown',
            label: 'pluscodes',
            options: 'DYNAMIC_BY_DESTINATION',
            helpText: 'hst_pluscode_help'
        },
        {
            name: 'exchangePacking',
            type: 'boolean',
            label: 'exchange_packing',
        },
        // Shipment Units with Carrier Selection
        {
            name: 'shipmentUnits',
            type: 'shipmentunit_carriers',
            label: 'shipment_units_carriers',
            helpText: 'hst_shipment_units_help'
        },
    ],
    saveObject: {
        destination: "netherlands",
        pluscodes: [],
        shipmentUnits: {
            EP: [],
            COL: [],
            BDLS: [],
            LNGT: [],
            SP: [],
            PLH: [],
            MP: []
        }
    },
    // Shipment unit specifications
    shipmentUnitSpecs: {
        EP: {
            code: 'EP',
            name: 'Euro Pallet',
            description: 'Lengte, breedte, hoogte en gewicht',
            dimensions: {
                lengthMin: 120,
                lengthMax: 120,
                widthMin: 80,
                widthMax: 80,
                heightMin: null,
                heightMax: 230,
                weightMin: 10,
                weightMax: 1500
            },
            displayInfo: 'W: 120x80cm, H: max 230cm, Gewicht: 10-1500kg'
        },
        COL: {
            code: 'COL',
            name: 'Colli',
            description: 'Lengte, breedte, hoogte en gewicht',
            dimensions: {
                lengthMin: null,
                lengthMax: 200,
                widthMin: null,
                widthMax: 200,
                heightMin: null,
                heightMax: 200,
                weightMin: 1,
                weightMax: 50
            },
            displayInfo: 'Max: 200x200x200cm, Gewicht: 1-50kg'
        },
        BDLS: {
            code: 'BDLS',
            name: 'Bundel t/m 274cm',
            description: 'Lengte, breedte, hoogte en gewicht',
            dimensions: {
                lengthMin: 200,
                lengthMax: 274,
                widthMin: null,
                widthMax: 240,
                heightMin: null,
                heightMax: 240,
                weightMin: 1,
                weightMax: 30
            },
            displayInfo: 'L: 200-274cm, Max: 240x240cm, Gewicht: 1-30kg'
        },
        LNGT: {
            code: 'LNGT',
            name: 'Bundel > 274cm',
            description: 'Lengte, breedte, hoogte en gewicht',
            dimensions: {
                lengthMin: 275,
                lengthMax: 700,
                widthMin: null,
                widthMax: 240,
                heightMin: null,
                heightMax: 240,
                weightMin: 1,
                weightMax: 30
            },
            displayInfo: 'L: 275-700cm, Max: 240x240cm, Gewicht: 1-30kg'
        },
        SP: {
            code: 'SP',
            name: 'Wegwerp Pallet',
            description: 'Lengte, breedte, hoogte en gewicht',
            dimensions: {
                lengthMin: 1,
                lengthMax: 200,
                widthMin: 1,
                widthMax: 240,
                heightMin: 1,
                heightMax: 230,
                weightMin: 10,
                weightMax: 1500
            },
            displayInfo: 'Max: 200x240x230cm, Gewicht: 10-1500kg'
        },
        PLH: {
            code: 'PLH',
            name: 'Halve Pallet',
            description: 'Lengte, breedte, hoogte en gewicht',
            dimensions: {
                lengthMin: 1,
                lengthMax: 100,
                widthMin: 50,
                widthMax: 60,
                heightMin: 1,
                heightMax: 220,
                weightMin: 10,
                weightMax: 400
            },
            displayInfo: 'Max: 100x60x220cm, Gewicht: 10-400kg'
        },
        MP: {
            code: 'MP',
            name: 'Mini Pallet',
            description: 'Lengte, breedte, hoogte en gewicht',
            dimensions: {
                lengthMin: 60,
                lengthMax: 60,
                widthMin: 50,
                widthMax: 50,
                heightMin: 20,
                heightMax: 115,
                weightMin: 10,
                weightMax: 150
            },
            displayInfo: 'W: 60x50cm, H: 20-115cm, Gewicht: 10-150kg'
        }
    },
    // Pluscode options organized by destination (hierarchical)
    pluscodesByDestination: {
        "netherlands": [
            { label: 'Voor 8 uur leveren', value: 'TM0800', tooltip: 'Voor 8 uur leveren' },
            { label: 'Voor 10 uur leveren', value: '930', tooltip: 'Voor 10 uur leveren' },
            { label: 'Voor 12 uur leveren', value: 'TM1200', tooltip: 'Voor 12 uur leveren' },
            { label: 'Na 14 uur leveren', value: '1400', tooltip: 'Na 14 uur leveren'},
            { label: 'Garantie levering', value: '1500', tooltip: 'Garantie levering' },
            { label: 'Bellen voor levering', value: 'FFBL', tooltip: 'Bellen voor levering' },
            { label: 'Werkplek afval retour', value: 'WERKAR', tooltip: 'Werkplek-Afval-Retour' },
            { label: 'Sleuteladres bezorgdepot', value: 'SLTEL1', tooltip: 'Sleuteladres-bezorgdepot' },
            { label: 'Legitimatieplicht', value: '18+', tooltip: 'Legitimatieplicht' },
            { label: 'Zaterdag levering', value: 'ZATERD', tooltip: 'Zaterdag levering' },
        ],
        "europe": []
    },
    // Validation rules for different configurations
    validationRules: {
        pluscodeCompatibility: {
            // Some pluscodes require extra information
            requiresExtraInfo: ['FFBL']
        }
    },
},
ampere: {
    fields: [
        // Parcel Type Configuration
        {
            name: 'parcelType',
            type: 'dropdown',
            label: 'parcel_type',
            translate: true,
            options: [
                { label: 'mailbox', value: 'MAILBOX' },
                { label: 'parcel', value: 'PARCEL' }
            ],
            default: 'PARCEL',
            helpText: 'ampere_parcel_type_help'
        },

        // Label Format Configuration
        {
            name: 'labelFormat',
            type: 'dropdown',
            label: 'label_format',
            translate: true,
            options: [
                { label: 'PDF', value: 'PDF' },
                { label: 'ZPL', value: 'ZPL' }
            ],
            default: 'PDF',
            helpText: 'ampere_label_format_help'
        },

        // Reference Type Configuration
        {
            name: 'referenceType',
            type: 'dropdown',
            label: 'reference_type',
            translate: true,
            options: [
                { label: 'order_number', value: 'order_number' },
                { label: 'picklist_number', value: 'picklist_number' }
            ],
            default: 'order_number',
            helpText: 'ampere_reference_type_help'
        },

        // Delivery Confirmation
        {
            name: 'deliveryConfirmation',
            type: 'dropdown',
            label: 'delivery_confirmation',
            translate: true,
            exclusiveGroup: 'ampere_services',
            options: [
                { label: 'none', value: '' },
                { label: 'signature', value: 'SIGNATURE' },
                { label: 'deliverycode', value: 'deliverycode' }
            ],
            default: '',
            helpText: 'ampere_delivery_confirmation_help'
        },

        // Age Check
        {
            name: 'minimalAgeCheck',
            type: 'dropdown',
            label: 'minimal_age_check',
            translate: true,
            exclusiveGroup: 'ampere_services',
            options: [
                { label: 'no_age_check', value: '' },
                { label: 'age_16_plus', value: '16+' },
                { label: 'age_18_plus', value: '18+' }
            ],
            default: '',
            helpText: 'ampere_age_check_help'
        },

        // Insurance Value
        {
            name: 'insuredValue',
            type: 'number',
            label: 'insured_value',
            exclusiveGroup: 'ampere_services',
            min: 0,
            max: 50000,
            step: 0.01,
            default: 0,
            helpText: 'ampere_insured_value_help'
        },

        // Boolean Options
        {
            name: 'statedAddressOnly',
            type: 'boolean',
            label: 'stated_address_only',
            exclusiveGroup: 'ampere_services',
            default: false,
            helpText: 'ampere_stated_address_only_help'
        },
        {
            name: 'returnWhenNotHome',
            type: 'boolean',
            label: 'return_when_not_home',
            exclusiveGroup: 'ampere_services',
            default: false,
            helpText: 'ampere_return_when_not_home_help'
        },
        {
            name: 'allowPickupPoint',
            type: 'boolean',
            label: 'allow_pickup_point',
            default: true,
            helpText: 'ampere_pickup_point_help'
        }
    ],

    // Exclusive field groups configuration
    exclusiveGroups: {
        ampere_services: {
            maxActive: 1,
            warningMessage: 'ampere_only_one_service_warning'
        }
    },

    saveObject: {
        parcelType: 'PACKAGE',
        labelFormat: 'PDF',
        referenceType: 'order_number',
        services: {
            insuredValue: 0,
            statedAddressOnly: false,
            deliveryConfirmation: '',
            returnWhenNotHome: false,
            minimalAgeCheck: ''
        },
        allowPickupPoint: true
    }
},
dpd: {
    fields: [
        {
            name: 'shippingMethod',
            type: 'dropdown',
            label: 'shipping_method',
            translate: true,
            options: [
                { label: 'DPD Predict', value: 'DPD_PREDICT' },
                { label: 'DPD Classic', value: 'DPD_CLASSIC' },
                { label: 'DPD Guarantee (E18)', value: 'DPD_GUARANTEE_E18' },
                { label: 'DPD Express (E10)', value: 'DPD_EXPRESS_E10' },
                { label: 'DPD Express (E12)', value: 'DPD_EXPRESS_E12' },
                { label: 'DPD Saturday', value: 'DPD_SATURDAY' },
                { label: 'DPD Classic Saturday', value: 'DPD_CLASSIC_SATURDAY' },
                { label: 'DPD Pickup', value: 'DPD_PICKUP' },
                { label: 'DPD Parcelletter', value: 'DPD_PARCELLETTER' }
            ],
            helpText: 'dpd_shipping_method_help'
        },
        {
            name: 'printLanguage',
            type: 'dropdown',
            label: 'print_language',
            translate: true,
            options: [
                { label: 'PDF', value: 'pdf' }
            ],
            helpText: 'dpd_print_language_help'
        },
        {
            name: 'printFormat',
            type: 'dropdown',
            label: 'print_format',
            translate: true,
            options: [
                { label: 'A6', value: 'A6' },
            ],
            helpText: 'dpd_print_format_help'
        },
        {
            name: 'includeReturnLabel',
            type: 'boolean',
            label: 'include_return_label',
            translate: true,
            helpText: 'dpd_return_label_help'
        },
        {
            name: 'language',
            type: 'dropdown',
            label: 'language',
            translate: true,
            options: [
                { label: 'nl_NL', value: 'nl_NL' },
                { label: 'en_US', value: 'en_US' },
                { label: 'de_DE', value: 'de_DE' },
                { label: 'fr_FR', value: 'fr_FR' },
            ],
            helpText: 'dpd_language_help'
        },
        {
            name: 'depot',
            type: 'text',
            label: 'depot',
            helpText: 'dpd_depot_help'
        },
        {
            name: 'name',
            type: 'text',
            label: 'name',
            helpText: 'dpd_name_help'
        },
        {
            name: 'street',
            type: 'text',
            label: 'street',
            helpText: 'dpd_street_help'
        },
        {
            name: 'housenumber',
            type: 'text',
            label: 'housenumber',
            helpText: 'dpd_housenumber_help'
        },
        {
            name: 'zipCode',
            type: 'text',
            label: 'zip_code',
            helpText: 'dpd_zip_code_help'
        },
        {
            name: 'city',
            type: 'text',
            label: 'city',
            helpText: 'dpd_city_help'
        },
        {
            name: 'country',
            type: 'dropdown',
            label: 'country',
            options: countriesForDropdown('nl').map(c => ({ label: c.name, value: c.value })),
            helpText: 'dpd_country_help'
        },
        {
            name: 'email',
            type: 'text',
            label: 'email',
            helpText: 'dpd_email_help'
        },
        {
            name: 'phoneNumber',
            type: 'text',
            label: 'phone_number',
            helpText: 'dpd_phone_number_help'
        },
        {
            name: 'vatNumber',
            type: 'text',
            label: 'vat_number',
            helpText: 'dpd_vat_number_help'
        },
        {
            name: 'hmrcNumber',
            type: 'text',
            label: 'hmrc_number',
            helpText: 'dpd_hmrc_number_help'
        },
        {
            name: 'eoriNumber',
            type: 'text',
            label: 'eori_number',
            helpText: 'dpd_eori_number_help'
        },
        {
            name: 'customsTerms',
            type: 'dropdown',
            label: 'customs_terms',
            translate: true,
            options: [
                { label: 'DAP NP - D&T paid by receiver', value: 'dap_receiver' },
                { label: 'DAP NP - D&T paid by sender', value: 'dap_sender' },],
            helpText: 'dpd_customs_terms_help'
        },
        {
            name: 'defaultHsCode',
            type: 'text',
            label: 'default_hs_code',
            helpText: 'dpd_default_hs_code_help'
        },
        {
            name: 'ageCheck',
            type: 'boolean',
            label: 'age_check',
            translate: true,
            helpText: 'dpd_age_check_help'
        },
        {
            name: 'labelQuantity',
            type: 'number',
            label: 'label_quantity',
            min: 1,
            max: 10,
            default: 1,
            helpText: 'dpd_label_quantity_help'
        }
    ],
    saveObject: {
        shippingMethod: "",
        printLanguage: "",
        printFormat: "",
        includeReturnLabel: "",
        language: "",
        depot: "",
        name: "",
        street: "",
        housenumber: "",
        zipCode: "",
        city: "",
        country: "",
        email: "",
        phoneNumber: "",
        vatNumber: "",
        hmrcNumber: "",
        eoriNumber: "",
        customsTerms: "",
        defaultHsCode: "",
        ageCheck: "",
        labelQuantity: 1
    }
},


};